exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".idb-editor {\n  width: 100%;\n  min-height: 200px;\n}\n", ""]);

